import { inject, onMounted, provide, reactive, ref } from "vue";
import type { WebBasicBizAddressGetMultiLevelSubListOut } from "../../api/types";
import { request } from "../../api/request";

const injectKey = Symbol("injectKey");

type District =
  WebBasicBizAddressGetMultiLevelSubListOut["districtList"][number];

export function createAreaContext() {
  const model = reactive<{ province?: District; city?: District }>({});

  const provinceList = ref<
    WebBasicBizAddressGetMultiLevelSubListOut["districtList"]
  >([]);

  onMounted(async () => {
    const data = await request("web.basicBiz.address.getMultiLevelSubList", {
      districtLevel: "province",
    });

    provinceList.value = data.districtList;
  });

  const ret = { model, provinceList };

  provide(injectKey, ret);
  return ret;
}

export function useAreaContext() {
  return inject<ReturnType<typeof createAreaContext>>(injectKey);
}
